import { Component, inject, isDevMode, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { RouterModule } from '@angular/router';
import { ConfirmDialogContainerComponent, ToastContainerComponent, AuthRedirectOverlayComponent, ForceLogoutDialogService } from '@dental-ui/ui';
import { SignalRService } from '@dental-ui/data-access';
import { autobarDocumentTitle, PORTAL_APP_DISPLAY_NAME } from '@dental-ui/shared/consts';

@Component({
  standalone: true,
  imports: [RouterModule, ToastContainerComponent, ConfirmDialogContainerComponent, AuthRedirectOverlayComponent],
  selector: 'app-root',
  templateUrl: './app.html',
  styleUrl: './app.scss',
})
export class App implements OnInit {
  private readonly titleService = inject(Title);
  /** Boots MessageHub (ForceLogout / notifications) while user is authenticated. */
  private readonly signalRService = inject(SignalRService);
  /** Confirm dialog host'tan önce ForceLogout handler'ını ayağa kaldırır */
  private readonly forceLogoutDialogService = inject(ForceLogoutDialogService);

  ngOnInit() {
    this.titleService.setTitle(autobarDocumentTitle(PORTAL_APP_DISPLAY_NAME, isDevMode()));
  }
}
